<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="section-gap">
        <div class="block">
          <div class="block width-1 fleft">
            <router-link class="button is-success" :to="{ name: 'specialAdvertisementEdit'}">新增</router-link>
          </div>
          <div v-if="adData.count > 0" class="clearfix">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="adData.currentPage"
              :page-size="adData.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="adData.count"
              class="fright">
            </el-pagination>
          </div>
          <div class="ad-list-container">

            <table class="table is-bordered">
              <thead>
              <tr>
                <td>ID</td>
                <td>名称</td>
                <td>图片</td>
                <td>应用页面</td>
                <td>开始时间</td>
                <td>结束时间</td>
                <td>曝光权重</td>
                <td>实时曝光率</td>
                <td>创建时间</td>
                <td>操作</td>
              </tr>
              </thead>
              <tbody>
              <tr class="list-cell" v-for="(item,index) in adData.adList">
                <td>{{item.advId}}</td>
                <td>{{item.name}}</td>
                <td>
                  <image-component :image="item.image" :width="300"></image-component>
                </td>
                <td>
                  <span v-for="(page,index) in item.pages">{{page}}<span v-if="index < item.pages.length - 1">、</span></span>
                </td>
                <td>{{item.startTime}}</td>
                <td>{{item.endTime}}</td>
                <td>
                  <div class="sort-wrap">
                    <input class="input width-1" v-model="item.weight" @change="weightChange(item.advId,item.weight)">
                  </div>
                </td>
                <td>
                  <span v-for="(subItem,index) in item.exposureRate">{{subItem}}<span v-if="index < item.exposureRate.length - 1">、</span></span>
                </td>
                <td>
                  {{item.createTime}}
                </td>
                <td>
                  <p>
                    <router-link class="button is-info" :to="{ name: 'specialAdvertisementEdit', query: { advId:item.advId}}">编辑</router-link>
                    <span class="button is-danger" @click="deleteMainAd(item.advId,index)">删除</span>
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="adData.count > 0" class="clearfix">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="adData.currentPage"
              :page-size="adData.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="adData.count"
              class="fright">
            </el-pagination>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">

  export default {
    data(){
      return{
        adData: {
          currentPage: 1,
          count: 0,
          pageSize: 10,
          adList: [],
        }
      }
    },
    computed: {

    },
    mounted: function () {
      this.$nextTick(function () {
        this.getAdImgList();
      })
    },
    methods:{
      handleCurrentChange(value) {
        if(this.adData.currentPage !== value){
          this.adData.currentPage = value;
          this.getAdImgList();
        }
      },
      //删除广告位
      deleteMainAd(advId,index){
        if (confirm('是否确定删除?')) {
          let params = {
            advId:advId
          }
          HttpRequest.post("/admin.php?method=activity11.removeSpecialAdv",params, true).then((response) => {
            if(response.data.success == 1){
              this.$message('删除成功！')
              this.adData.adList.splice(index,1);
            }
          });
        }
      },
      //改变排序
      weightChange(advId,weight){
        let params = {
          weight:weight,
          advId:advId
        }
        HttpRequest.post("/admin.php?method=activity11.doSaveSpecialAdvWeight",params, true).then((response) => {
          if(response.data.success == 1){
            this.$message("修改成功")
          }
        }, (response) => {

        });
      },
      //获取广告位列表
      getAdImgList(){
        HttpRequest.get("/admin.php?method=activity11.getSpecialAdvList", {page:this.adData.currentPage, pageSize: this.adData.pageSize}, true).then((response) => {
          this.adData.adList = response.data.list;
          this.adData.count = response.data.count;
        }, (response) => {

        });
      },
    }
  }
</script>
<style lang="less" scoped>
  .ad-list-container{
    margin: 30px 0;
    .list-cell{
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .ad-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 300px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
  }
  .white-space {
    white-space: normal;
  }
</style>
